module.exports = __webpack_public_path__ + "static/media/vrb_boxed.daf6baec.svg";